<template>
  <div style="margin-top: -12px">
    <v-container fluid>
      <v-card flat class="disable-scrollbars">
        <v-card-text>
          <div style="clear: both"></div>
          <template>
            <v-data-table
              :headers="headers"
              :items="getAllCTransactions"
              :items-per-page="15"
              @click:row="showSingleTransaction"
              style="cursor: pointer"
            >
              <template v-slot:item.transactionType="{ item }">
                <v-chip
                  :color="getColor(item.transactionType)"
                  dark
                  outlined
                  label
                  style="width: 125px"
                >
                  <v-icon left size="16">{{
                    getIcon(item.transactionType)
                  }}</v-icon>
                  {{ item.transactionType }}
                </v-chip>
              </template>
              <template v-slot:item.transactionAmount="{ item }">
                <span :style="getColorMount(item.transactionAmount)">
                  {{
                    new Intl.NumberFormat("de-DE").format(
                      item.transactionAmount
                    )
                  }}
                  Akz
                </span>
              </template>

              <template v-slot:item.dateTransaction="{ item }">
                <span :style="getColorMount(item.dateTransaction)">
                  {{ formatData(item.dateTransaction) }}
                </span>
              </template>
            </v-data-table>
          </template>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapHelper } from "@/store/helper";
import eventBus from "@/main";

export default {
  name: "HistoryClient",
  data() {
    return {
      paginat: false,
      footeHiden: false,
      // desserts: this.$store.getters.getAllCTransactions,
      headers: [
        {
          text: "REFERÊNCIA",
          align: "start",
          sortable: false,
          value: "transactionDescription"
        },
        { text: "TIPO", value: "transactionType" },
        { text: "MONTANTE", value: "transactionAmount" },
        { text: "PRODUTO", value: "productName" },
        { text: "DATA", value: "dateTransaction" }
      ]
    };
  },
  methods: {
    getColor(type) {
      if (type === "Entrada") return "green";
      else if (type === "Saída") return "red";
      else return "orange";
    },
    getIcon(type) {
      if (type === "Entrada") return "mdi-arrow-up";
      else if (type === "Saída") return "mdi-arrow-down";
      else return "mdi-swap-horizontal";
    },
    getColorMount() {
      return "color:#1976d2c4";
    },
    formatData(convertData) {
      let format = new Date(convertData);
      return format.toISOString().split("T")[0];
    },
    showSingleTransaction(item) {
      if (item) {
        this.drawer = !this.drawer;
        const payload = {
          dialog: true,
          drawer: true,
          operation: item
        };
        eventBus.$emit("openModalTransactionClient", payload);
      }
    }
  },
  computed: {
    ...mapHelper
  }
};
</script>

<style scoped></style>
